// removed by extract-text-webpack-plugin
module.exports = {"svgandtext":"_2OvblQ4xq558YKDdNmxPWD","svgandtext-text":"_2gHyCPG-VtaKdmw0gS_JUw","svgandtextText":"_2gHyCPG-VtaKdmw0gS_JUw","svgandtext-icon":"_3GKLecjmOL1-C3xwGIqVGY","svgandtextIcon":"_3GKLecjmOL1-C3xwGIqVGY"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/elements/svgAndText.css
// module id = 377
// module chunks = 0